import { SxProps } from '@mui/material'

import { BeachPlanFirestoreData, BeachPlanSpotIconMaxWidths } from '../../../types/beachPlan.types'

export interface SelectedSpot {
  id: number
  beachPlanId: string
  beachPlanName?: string
  name: string
  price?: number
  type: string
  persons: number
  minimumPersons: number
  maximumPersons: number
}

export interface BeachAsset {
  top: number
  left: number
  id?: number
  beachPlanId?: string
  beachPlanName?: string
  price?: number | null
  name?: string
  type: BeachElementType
  defaultPersons?: number
  minimumPersons?: number
  maximumPersons?: number
}
// TODO to be removed
export enum Configuration {
  BEACH_PLAN = 'beachPlan',
  BEACH_BACKGROUND = 'beachBackground',
  BEACH_BAR_BANNER = 'beachBarBanner',
  BEACH_BAR_LOGO = 'beachBarLogo',
  BEACH_BAR_FACEBOOK = 'beachBarFacebook',
  BEACH_BAR_INSTAGRAM = 'beachBarInstagram',
  BEACH_BAR_LINKEDIN = 'beachBarLinkedin',
  CONTACT = 'contact',
  SERVICES = 'services',
  POLICY = 'policy',
  PRICE_LIST = 'pricelist',
  INFO_TEXT = 'infoText',
  PAYMENT_PERCENTAGE = 'paymentPercentage',
}

// TODO to be removed

// Construct Configuration interface dynamically from Configuration enum
export type ConfigurationType = {
  id: string
} & {
  [key in Configuration]: string
}

export interface ImageDimensions {
  width: number
  height: number
}

export enum BeachElementType {
  UMBRELLA = 'umbrella',
  POUF = 'pouf',
  CABANA = 'cabana',
  RUNWAY_HORIZONTAL = 'runway_horizontal',
  RUNWAY_VERTICAL = 'runway_vertical',
  RUNWAY_CROSS = 'runway_cross',
  RUNWAY_T_LEFT = 'runway_t_left',
  RUNWAY_T_TOP = 'runway_t_top',
  RUNWAY_T_RIGHT = 'runway_t_right',
  RUNWAY_T_BOTTOM = 'runway_t_bottom',
  SHOWER = 'shower',
  WC = 'wc',
  BAR = 'bar',
  LIFE_GUARD = 'life_guard',
  CHANGE_ROOM = 'change_room',
  JET_SKI = 'jetski',
  WINDSURF = 'windsurf',
}

export interface BeachPlanProps {
  background: string
  spots: BeachAsset[]
  alreadyReservedSpots: number[]
  isLoading: boolean
  rows: number
  columns: number
  spotIconMaxWidths?: BeachPlanSpotIconMaxWidths
  selectedSpots: SelectedSpot[]
  toggleSelection: (selectedSpot: SelectedSpot) => void
  beachPlans?: BeachPlanFirestoreData[]
  selectedBeachPlanId?: string
  onBeachPlanChange?: (beachPlanId: string) => void
  sx?: SxProps
  disableClickToggle?: boolean
  actionIcon?: React.ReactNode
  onActionClick?: () => void
  onReservedSpotClick?: (spot: BeachAsset) => void
  isDisabled?: boolean
  viewOnlyMode?: boolean
  onViewOnlySpotClick?: (spot: BeachAsset) => void
}

export type WrappedComponentProps = {} & BeachPlanProps

export type BeachElementImages = { image: string; selectedImage: string; unavailableImage: string; disabledImage: string }
